import React from 'react';
import { Button } from './Button';

/**
 * Empty states with icon, title, description, CTA.
 */
export function EmptyState({ icon: Icon, title, description, actionLabel, onAction, className = '' }) {
  return (
    <div className={`ui-empty-state ${className}`.trim()}>
      {Icon && (
        <div className="ui-empty-state__icon">
          <Icon size={48} />
        </div>
      )}
      {title && <h3 className="ui-empty-state__title">{title}</h3>}
      {description && <p className="ui-empty-state__desc">{description}</p>}
      {actionLabel && onAction && (
        <Button variant="primary" onClick={onAction} className="ui-empty-state__cta">
          {actionLabel}
        </Button>
      )}
    </div>
  );
}
